'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialGithubOutline = function IoSocialGithubOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 8 17.5 18 0 7.9-5 14.7-12 17h-0.3c-0.6 0-0.9-0.5-0.9-0.9 0-0.7 0.1-2.5 0.1-4.9 0-1.6-0.7-2.8-1.3-3.3 3.9-0.5 8.1-2 8.1-8.9 0-1.9-0.7-3.6-1.8-4.8 0.1-0.5 0.8-2.3-0.2-4.8h-0.4c-0.6 0-2.1 0.3-4.4 1.9-1.4-0.4-2.9-0.6-4.4-0.6s-3 0.2-4.4 0.6c-2.3-1.6-3.8-1.9-4.4-1.9h-0.4c-1 2.5-0.3 4.3-0.2 4.8-1.1 1.2-1.8 2.9-1.8 4.8 0 6.9 4.1 8.4 8 8.9-0.5 0.4-0.9 1.2-1.1 2.4-0.5 0.2-1.2 0.5-2 0.5-1 0-2.2-0.4-3.1-2 0 0-1-1.7-2.7-1.9-0.2 0-1.7 0-0.1 1.1 0 0 1.2 0.6 2 2.7 0 0 0.7 2.6 4.1 2.6 0.6 0 1.1 0 1.7-0.2v3c0 0.4-0.2 0.9-0.8 0.9h-0.3c-7-2.3-12-9.1-12-17 0-10 7.8-18 17.5-18z m-6.1 32.5c-1.2 0-2.2-0.3-3-0.7 1.1 0.8 2.2 1.3 3.5 1.8v-1.1h-0.5z m0.9-5.7c-1.3-0.3-2.8-0.8-4.1-1.9 0.5 0.5 0.9 0.9 1 1.3 0.6 0.9 1.1 1.3 2 1.3 0.3 0 0.7-0.1 0.9-0.2 0.1-0.1 0.1-0.3 0.2-0.5z m14.8 4.6c1.3-1 2.5-2.2 3.5-3.6 2.1-2.9 3.1-6.2 3.1-9.8 0-2.3-0.3-4.6-1.2-6.6-0.8-1.9-2-3.7-3.5-5.3s-3.2-2.7-5.2-3.5c-2-0.9-4.1-1.4-6.3-1.4s-4.3 0.5-6.3 1.4c-2 0.8-3.7 1.9-5.2 3.5s-2.7 3.3-3.5 5.3c-0.9 2-1.2 4.3-1.2 6.6 0 3.6 1 6.9 3.1 9.8 0.8 1.1 1.7 2.1 2.7 3-0.5-0.6-0.9-1.3-1-1.7-0.6-1.4-1.2-1.9-1.3-2h-0.2v-0.1c-0.4-0.2-1.6-1-1.2-2.2 0.3-0.7 1-1.1 2-1.1h0.1c1 0 1.8 0.4 2.5 1-1.7-1.5-2.9-3.8-2.9-7.7 0-1.8 0.5-3.6 1.6-5.1-0.2-1-0.5-2.7 0.4-4.9l0.2-0.6 0.6-0.1c0.1 0 0.4-0.1 0.8-0.1 0.9 0 2.4 0.2 4.7 1.7 1.3-0.3 2.7-0.5 4.1-0.5 1.4 0 2.8 0.2 4.1 0.5 2.3-1.5 3.8-1.7 4.7-1.7 0.4 0 0.7 0.1 0.8 0.1l0.6 0.1 0.2 0.6c0.9 2.1 0.6 3.9 0.4 4.9 1.1 1.5 1.6 3.2 1.6 5.1 0 7.2-4.3 9.2-7.2 9.8 0.3 0.6 0.4 1.4 0.4 2.3v4.5c1.4-0.5 2.8-1.3 4-2.2z' })
        )
    );
};

exports.default = IoSocialGithubOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-github-outline.js
// module id = 2677
// module chunks = 0